import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError, QueryStatus } from "@reduxjs/toolkit/query";

// a simple RTK Query result that works for our use cases
export interface RtkQueryResult<T> {
	data?: T;
	isUninitialized: boolean;
	isLoading: boolean;
	isFetching: boolean;
	isError: boolean;
	isSuccess: boolean;
	status: QueryStatus;
	error?: FetchBaseQueryError | SerializedError;
	fulfilledTimeStamp?: number;
}

export const isFetchBaseQueryError = (
	error: FetchBaseQueryError | SerializedError,
): error is FetchBaseQueryError => "status" in error && ("data" in error || "error" in error);

export const isSerializedError = (
	error: FetchBaseQueryError | SerializedError,
): error is SerializedError =>
	"name" in error || "message" in error || "stack" in error || "code" in error;

export const rtkqErrorToString = (error: FetchBaseQueryError | SerializedError) => {
	if (isFetchBaseQueryError(error)) {
		if (error.status === "FETCH_ERROR") {
			return "There was an error fetching data.";
		} else if (error.status === "PARSING_ERROR") {
			return "There was an error parsing the reply from the server.";
		} else if (error.status === "TIMEOUT_ERROR") {
			return "The data request timed out.";
		} else if (error.status === "CUSTOM_ERROR") {
			return error.error;
		} else if (error.status === 400 && typeof error.data === "string") {
			return error.data;
		}
	} else if (isSerializedError(error)) {
		if (error.name && error.message) {
			return `${error.name}: ${error.message}`;
		} else if (error.message) {
			return error.message;
		} else if (error.name) {
			return `${error.name}: An error occured while processing the request.`;
		}
	}
	return "An error occured while processing the request.";
};
